function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3207 3.09C10.9111 2.91006 10.4316 2.99003 10.1119 3.27994L4.8971 7.95847H3.11888C2.4995 7.95847 2 8.44832 2 9.04813V14.9563C2 15.5561 2.4995 16.0459 3.11888 16.0459H4.8971L10.1119 20.7045C10.3217 20.8944 10.5914 20.9944 10.8711 20.9944C11.021 20.9944 11.1808 20.9644 11.3207 20.9044C11.7203 20.7345 11.98 20.3446 11.98 19.9147V4.08969C11.98 3.65982 11.7203 3.26994 11.3207 3.1V3.09ZM9.98202 17.9253L5.97602 14.3365L5.61638 14.0666H4.01798V9.91786H5.24675L5.71628 9.88787L9.99201 6.05907V17.9154L9.98202 17.9253ZM19.4126 11.9972L22 14.5864L20.5914 15.996L18.004 13.4068L15.4166 15.996L14.008 14.5864L16.5954 11.9972L14.008 9.40802L15.4166 7.99846L18.004 10.5876L20.5914 7.99846L22 9.40802L19.4126 11.9972Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=VolumeOff.js.map